export default "__VITE_ASSET__BI20yOrB__"